<div
  [ngClass]="{ 'pt-16': !isMultiUpload }"
  class="flex items-center justify-between pb-16 px-16"
>
  <div class="flex-grow">
    <div
      class="flex-grow flex justify-end items-center text-8 leading-15px py-4 px-6 pl-12"
    >
      &nbsp;
      <div *ngIf="isAllLoaded" class="font-semibold">
        {{ 'common.done' | transloco }}
      </div>
    </div>
    <mat-progress-bar
      mode="determinate"
      [value]="totalProgressPercent"
    ></mat-progress-bar>

    <div
      class="flex justify-between items-center text-8 px-8 leading-15px mt-4 font-semibold"
    >
      <div class="flex justify-start items-center">
        <span *ngIf="!isAllLoaded"
          >{{ uploadedSize | number: '1.2-2' }} /
        </span>
        <span class="font-normal"
          >{{ totalSize | number: '1.2-2' }} {{ sizeType }}</span
        >
      </div>
      <span *ngIf="!isAllLoaded"
        >{{ totalProgressPercent | number: '1.0-2' }}%</span
      >
      <div
        *ngIf="isAllLoaded"
        class="w-12 h-12 rounded-full mr-3 bg-gray-100 flex items-center justify-content-center"
      >
        <tdv-icon name="check" class="icon-dark w-16 h-16"></tdv-icon>
      </div>
    </div>
  </div>
</div>
